<template>
  <div>
    <h1>
      <el-button icon="el-icon-caret-left" @click="goPrevMonth"></el-button>
      {{ year }}年 {{ month }}月 シフトSummary
      <el-button icon="el-icon-caret-right" @click="goNextMonth"></el-button>
    </h1>
    <el-button type="success" @click="isShown=true">表示変更</el-button>
    <el-button type="primary" :disabled="isLoading" @click="fetchData">データ読み込み</el-button>
    <div v-show="isLoading">
      <el-progress type="circle" :percentage="progressRate"></el-progress>
      <el-tag
        v-for="info in progress" :key="info.shopPk"
        :type="progressTagType(info)">{{ info.name }}
      </el-tag>
    </div>
    <el-dialog :visible.sync="isShown" title="表示項目設定" width="80%">
      <el-form>
        <el-form-item>
          <el-checkbox v-model="showOpenCloseTime">開店／閉店時間を表示</el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-transfer
            class="shop-transfer"
            filterable
            v-model="selectedShops"
            :data="transferShops"
            :titles="['非表示', '表示中']">
          </el-transfer>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="isShown=false" type="primary">閉じる</el-button>
      </div>
    </el-dialog>
    <div class="data-area" v-show="dates.length">
      <el-table
        :data="dates"
        class="shift-summary-table"
        border>
        <el-table-column
          label="日付"
          prop="printDate"
          fixed="left"
          align="center"
          width="70">
        </el-table-column>
        <template v-for="header in headerShops">
          <el-table-column
            align="center"
            :key="header.shopPk"
            :label="header.name">
            <el-table-column
              width="60"
              label="開店時間"
              align="center"
              v-if="showOpenCloseTime">
              <template slot-scope="scope">
                <div>{{ shiftData[scope.row.date][header.shopPk].openTime }}</div>
              </template>
            </el-table-column>
            <el-table-column
              width="60"
              label="閉店時間"
              v-if="showOpenCloseTime"
              align="center">
              <template slot-scope="scope">
                <div>{{ shiftData[scope.row.date][header.shopPk].closeTime }}</div>
              </template>
            </el-table-column>
            <el-table-column
              width="60"
              label="開店人数"
              align="right"
              >
              <template slot-scope="scope">
                <div>{{ openingStaffNum(scope.row.date, header.shopPk) }}</div>
              </template>
            </el-table-column>
            <el-table-column
              width="60"
              label="閉店人数"
              align="right"
              >
              <template slot-scope="scope">
                <div>{{ closingStaffNum(scope.row.date, header.shopPk) }}</div>
              </template>
            </el-table-column>
            <el-table-column
              label="総労働時間"
              align="right"
              width="75"
              >
              <template slot-scope="scope">
                <div>{{ workingTime(scope.row.date, header.shopPk) }}</div>
              </template>
            </el-table-column>
            <el-table-column
              label="超過判定"
              align="center"
              width="60">
              <template slot-scope="scope">
                <el-tag type="danger" v-if="isShort(scope.row.date, header.shopPk)">不足</el-tag>
                <el-tag type="warning" v-else-if="isOver(scope.row.date, header.shopPk)">超過</el-tag>
                <el-tag type="success" v-else>適切</el-tag>
              </template>
            </el-table-column>
          </el-table-column>
        </template>
      </el-table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import ShopType from '@/consts/ShopType'
import zeroPadding from '@/misc/zeroPadding'
import Promise from 'bluebird'
import throat from 'throat'

import reasonableMinutes from '@/mock/reasonableMinutes'

export default {
  name: 'ShiftIndex',
  props: {
    year: {
      type: [Number, String],
      required: false,
    },
    month: {
      type: [Number, String],
      required: false,
    },
  },
  watch: {
    $route: {
      handler: 'fetchData',
      immediate: true,
    },
  },
  data () {
    return {
      isShown: false,
      isLoading: false,
      progress: [],
      shops: [],
      showOpenCloseTime: true,
      selectedShops: [],
      headerShops: [],
      form: {
      },
      shiftData: {},
      dates: [],
    }
  },
  computed: {
    transferShops () {
      return this.shops.map(shop => {
        return {
          key: shop.pk,
          label: `${shop.code} ${shop.name}`,
        }
      })
    },
    progressRate () {
      if (this.progress.length === 0) {
        return 0
      }
      return Math.floor((this.progress.filter(x => x.isDone).length * 100) / this.progress.length)
    },
  },
  mounted () {
    this.fetchShopData()
  },
  methods: {
    fetchShopData () {
      this.isLoading = true
      this.$request.shops.list().then(res => {
        this.shops = res.body.results.filter(x => x.shopType === ShopType.SHOP)
        const selectedShop = this.shops.find(x => x.pk === this.selectedShop)
        if (selectedShop) {
          this.shop = this.selectedShop
        }
      }).finally(() => {
        this.isLoading = false
        if (this.shop) {
          this.fetchData()
        }
      })
    },
    fetchData () {
      if (this.isLoading) {
        return
      }
      this.isLoading = true
      let requests = []
      let headerShops = []
      this.progress = []
      const Task = throat(Promise)(2)
      this.selectedShops.forEach(shopPk => {
        const shopData = this.shopData(shopPk)
        let info = {
          inProgress: false,
          isDone: false,
          shopPk: shopPk,
          name: shopData.name,
        }
        this.progress.push(info)
        requests.push(Task(() => {
          info.inProgress = true
          return new Promise(resolve => {
            this.$request.shifts.shiftList(shopPk, this.year, this.month).then(res => {
              info.inProgress = false
              info.isDone = true
              resolve({results: res.body.results, shop: shopPk})
            })
          })
        }))
        headerShops.push({
          name: shopData.name,
          shopPk: shopPk,
        })
      })
      Promise.all(requests).then(values => {
        let items = {}
        let dates = []
        values.forEach(data => {
          data.results.forEach(row => {
            if (!items[row.date]) {
              items[row.date] = {}
              dates.push({
                date: row.date,
                printDate: moment(row.date).locale('ja').format('DD (ddd)'),
              })
            }
            items[row.date][data.shop] = row
          })
        })
        this.headerShops = headerShops
        this.dates = dates
        this.shiftData = items
      }).finally(() => {
        this.isLoading = false
      })
    },
    shopData (pk) {
      return this.shops.find(shop => shop.pk === pk)
    },
    goPrevMonth () {
      let tmp = moment().year(this.year).month(this.month - 1).set('date', 10).add(-1, 'months')
      const params = {
        year: tmp.year(),
        month: tmp.month() + 1,
      }
      this.$router.push({
        name: 'ShiftSummary',
        params,
      })
    },
    goNextMonth () {
      let tmp = moment().year(this.year).month(this.month - 1).set('date', 10).add(1, 'months').day(1)
      const params = {
        year: tmp.year(),
        month: tmp.month() + 1,
      }
      this.$router.push({
        name: 'ShiftSummary',
        params,
      })
    },
    isShort (date, shopPk) {
      let row = this.shiftData[date][shopPk]
      let sum = 0
      row.shifts.forEach(x => {
        sum += x.workMinutes
      })
      let tmp = row.openTime.split(':')
      const openHour = parseInt(tmp[0])
      const openMinute = parseInt(tmp[1])
      const openTime = openHour * 60 + openMinute
      tmp = row.closeTime.split(':')
      const closeHour = parseInt(tmp[0])
      const closeMinute = parseInt(tmp[1])
      const closeTime = closeHour * 60 + closeMinute

      return sum < (closeTime - openTime) * 2
    },
    isOver (date, shopPk) {
      let row = this.shiftData[date][shopPk]
      let shopData = this.shopData(shopPk)
      let sum = 0
      row.shifts.forEach(x => {
        sum += x.workMinutes
      })
      const tmp = reasonableMinutes.find(x => x.code === shopData.code)
      const minutes = tmp ? tmp.minutes : 1800
      return sum > minutes
    },
    openingStaffNum (date, shopPk) {
      let row = this.shiftData[date][shopPk]
      let tmp = row.openTime.split(':')
      const openHour = parseInt(tmp[0])
      const openMinute = parseInt(tmp[1])

      let num = 0
      const openTime = openHour * 60 + openMinute
      row.shifts.filter(shift => !shift.isVacation && !shift.isPaidVacation).forEach(shift => {
        const tmp = shift.startHour * 60 + shift.startMinute
        if (tmp <= openTime) {
          num++
        }
      })
      return num
    },
    closingStaffNum (date, shopPk) {
      let row = this.shiftData[date][shopPk]
      let tmp = row.closeTime.split(':')
      const closeHour = parseInt(tmp[0])
      const closeMinute = parseInt(tmp[1])

      let num = 0
      const closeTime = closeHour * 60 + closeMinute
      row.shifts.filter(shift => !shift.isVacation && !shift.isPaidVacation).forEach(shift => {
        const tmp = shift.endHour * 60 + shift.endMinute
        if (tmp >= closeTime) {
          num++
        }
      })
      return num
    },
    workingTime (date, shopPk) {
      let row = this.shiftData[date][shopPk]
      let minutes = 0
      row.shifts.filter(shift => !shift.isVacation).forEach(shift => {
        if (shift.workMinutes) {
          minutes += shift.workMinutes
        }
      })
      const hour = Math.floor(minutes / 60)
      const minute = zeroPadding(minutes % 60)
      return `${hour}:${minute}`
    },
    progressTagType (info) {
      if (info.isDone) {
        return 'success'
      } else if (info.inProgress) {
        return 'warning'
      }
      return 'info'
    },
  },
}
</script>

<style>
.shop-transfer .el-transfer-panel {
  width: 320px;
}

.el-table.shift-summary-table {
  font-size: small;
}

.el-table.shift-summary-table td {
  padding: 0;
}

.el-table.shift-summary-table th > div.cell,
.el-table.shift-summary-table td > div.cell {
  padding-left: 3px;
  padding-right: 3px;
}

.el-table.shift-summary-table td.working-time > div.cell {
  font-size: x-small;
  line-height: initial;
}

</style>



// WEBPACK FOOTER //
// src/components/Shift/Summary.vue